import React, { useEffect} from "react";
import { Divider, Icon,  } from 'rsuite';
import $ from 'jquery';

const CustomDrawer = ({show, close, headerText, children}) => {

    useEffect(() => {
        $("body" ).on( "click", ".side_container-content", close )

        return () => $("body" ).off( "click", ".side_container-content", close );
    },[close]);

    return <>
            <div className={show ? "custom-drawer-backdrop" : "custom-drawer-backdrop_hide"}></div>
            <div className={show ? "custom-drawer_open" : "custom-drawer_close"} onClick={(event)=>{event.stopPropagation()}}>
                <div className="custom-drawer-head" >
                    <p className="header-secondary" style={{ fontWeight: '600', letterSpacing: '.05em'}}>{headerText}</p>
                    <div className="head-icon" onClick={close}><Icon icon="close" /></div>       
                </div>
                <Divider />
                {children}
            </div>
        </>
}

export default CustomDrawer;